import { createElement, memo, useContext } from '@max/max';
import View from '@hfe/max-view';
import LText from '@max/leez-text';
import TextButton from '@max/leez-text-button';
import { navigateToPage } from '../../utils/index';
import './index.scss';
const Header = (props) => {
    const ctx = useContext(global._EngineGlobalContext);
    const { _raptorReport } = ctx || {};
    const { title, titleColor, secondEntryText, secondEntryColor, secondEntryLink } = props || {};
    const onPress = () => {
        if (!secondEntryLink)
            return;
        navigateToPage(secondEntryLink, err => {
            _raptorReport === null || _raptorReport === void 0 ? void 0 : _raptorReport.reportLog('神券二级入口跳链校验失败', new Error(err), {
                level: 'warn'
            });
        }, err => {
            _raptorReport === null || _raptorReport === void 0 ? void 0 : _raptorReport.reportLog('神券二级入口跳转失败', new Error(err), {
                level: 'warn'
            });
        });
    };
    return <View className="magicmember-header-container">
      <LText type="title2" lineClamp={1} color={titleColor} text={title}/>
      <TextButton x-if={secondEntryText && secondEntryLink} rightIcon="jiantouxianyou" color={secondEntryColor} onPress={onPress} text={secondEntryText}/>
    </View>;
};
export default memo(Header);
